// Changes that would remove the signed-in user's own access (the incident of 2026-10-15: an editor
// ended their own project membership, which revoked their roles at once). The API refuses them
// (409 with a Hebrew message); the screen names the user's own record and does not offer them.
import { ACCESS_SAFETY_MESSAGES } from '@sivan/shared';

export const SELF_LABEL = 'החשבון שלך';

export const SELF_REMOVAL_NOTE = 'לא ניתן להסיר את עצמך מהצוות';

export const SELF_ROLES_NOTE =
  'אלה ההרשאות שלך: ניתן להוסיף הרשאה שבתחומך, אך לא להסיר הרשאה מעצמך. הסרה מתבצעת על ידי מנהל אחר.';

export const SELF_DEACTIVATION_NOTE = 'זו הרשומה שלך: לא ניתן לסמן את עצמך כלא פעיל.';

/** The Hebrew explanation of an access-safety refusal (409 `conflict.code`), if it is one. */
export const accessSafetyMessage = (code: string): string | undefined =>
  Object.entries(ACCESS_SAFETY_MESSAGES).find(([key]) => key === code)?.[1];
